// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__U0Br2","author":"Table_author__17pyF","authorImage":"Table_authorImage__v6P4O","unreadRow":"Table_unreadRow__2DSBR"};